module.exports = global["MobileDetect"] = require("-!./mobile-detect.js");


//////////////////
// WEBPACK FOOTER
// ./~/mobile-detect/mobile-detect.js-exposed
// module id = 842
// module chunks = 1